/* eslint-disable @typescript-eslint/no-magic-numbers */

import { OrderBy } from 'src/app/@lib/order-by';
import { environment } from '../../environments/environment';

declare let navigator: Navigator;

// Do NEVER remove or modify the following line (appVersionFromConfigXml)
// under any circumstances as the world will explode if you do so!
const appVersionFromConfigXml = '0.9.3_RC1';

export const pStyle: CSSStyleDeclaration = getComputedStyle(document.documentElement);

export class C {
  public static ENV: string = environment.name;

  public static STORAGE_PREFIX_SEPARATOR: string = 'ಠ_ಠ';
  public static STORAGE_APP_PREFIX: string = 'nakos-database';
  public static STORAGE_PREFIX: string = `${C.STORAGE_APP_PREFIX}-${environment.name}${C.STORAGE_PREFIX_SEPARATOR}`;

  // for web
  public static APP_VERSION: any = {
    name: 'NAKOS',
    number: appVersionFromConfigXml,
    package: 'berlin.prototype.nakos',
  };

  public static availableLanguages: string[] = ['de'];
  public static defaultLanguage: string = 'de';

  public static appReloadThreshold: number = 3600000;

  public static DEFAULT_LIMIT: number = 50;
  public static DEFAULT_TIMEOUT: number = 30000;
  public static DEFAULT_ORDER_BY: OrderBy = {
    createdAt: 'DESC',
  };

  public static status: any = {
    unauthorized: 401,
    unprocessableEntity: 422,
  };

  public static colors: any = {
    danger: pStyle.getPropertyValue('--ion-color-danger'),
    dark: pStyle.getPropertyValue('--ion-color-dark'),
    light: pStyle.getPropertyValue('--ion-color-light'),
    medium: pStyle.getPropertyValue('--ion-color-medium'),
    primary: pStyle.getPropertyValue('--ion-color-primary'),
    secondary: pStyle.getPropertyValue('--ion-color-secondary'),
  };

  /**
   * @param {{deviceMemory:number}} navigator
   */
  public static isLowEndDevice(): boolean {
    const DEVICE_MEMORY = 2;

    const key = 'deviceMemory';

    return navigator && navigator[key] <= DEVICE_MEMORY;
  }
}
